import React, { useEffect } from "react";
import { useDropzone } from "react-dropzone";

import { Box, Icon, Text, useColorModeValue, VStack } from "@chakra-ui/react";
import { AiOutlineFile } from "react-icons/ai";
import { FiUploadCloud } from "react-icons/fi";
// import "./dropzone.css";

export default function Dropzone({ onDrop, accept, maxSize, maxFiles, description, error }) {
	const { getRootProps, getInputProps, fileRejections, isDragActive, acceptedFiles } = useDropzone({
		accept,
		onDrop,
		maxSize,
		maxFiles,
	});

	const borderColor = useColorModeValue("teal.300", "teal.500");
	const bgColor = useColorModeValue("gray.50", "gray.700");
	const hoverBg = useColorModeValue("gray.100", "gray.600");

	const files = () => {
		return acceptedFiles.length > 0 ? (
			<VStack spacing={2} mt={4} align="stretch">
				{acceptedFiles.map((f, index) => (
					<Box key={index} p={2} borderRadius="md" bg={bgColor} display="flex" alignItems="center">
						<Icon as={AiOutlineFile} mr={2} />
						<Text fontSize="sm">{f.name}</Text>
					</Box>
				))}
			</VStack>
		) : null;
	};

	useEffect(() => {
		console.log(acceptedFiles);
	}, [acceptedFiles]);

	useEffect(() => {
		if (fileRejections.length > 0) {
			console.log(fileRejections[0].errors[0].message);
			console.log(fileRejections);
			alert("Some files were rejected");
		}
	}, [fileRejections]);
	// const theme = useTheme();

	const dropzoneStyle = {
		padding: "2rem",
		border: "2px dashed",
		borderColor: error ? "red.300" : borderColor,
		backgroundColor: bgColor,
		borderRadius: "xl",
		transition: "all 0.2s",
		cursor: "pointer",
		_hover: {
			backgroundColor: hoverBg,
		},
	};

	return (
		<VStack spacing={4} width="100%">
			<Box {...getRootProps()} sx={dropzoneStyle} width="100%" _hover={{ bg: hoverBg }} transition="all 0.2s">
				<input {...getInputProps()} />
				<VStack spacing={2}>
					<Icon as={FiUploadCloud} boxSize={8} color={error ? "red.300" : borderColor} />
					{isDragActive ? (
						<Text color={error ? "red.300" : "inherit"}>Drop files here...</Text>
					) : (
						<>
							<Text color={error ? "red.300" : "inherit"} fontWeight="medium">
								Drag & drop or click to upload
							</Text>
							<Text fontSize="sm" color="gray.500">
								{description || "Max file size: 20MB"}
							</Text>
						</>
					)}
				</VStack>
			</Box>
			{files()}
		</VStack>
	);
}
